<script lang="ts" setup>
const { getCarousel } = useGames()

const { data } = useAsyncData('carousel', () => getCarousel(), {
  getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key] || nuxtApp.static.data[key],
  transform: data => data?.results
})
</script>

<template>
  <UCarousel
    v-slot="{ item }"
    dots
    :items="data"
    :autoplay="{ delay: 5000 }"
    :loop="true"
    class="w-full h-full mx-auto col-span-2 lg:col-span-4! xl:col-span-4!"
    :ui="{
      root: 'w-full h-full',
      viewport: 'w-full h-full rounded-xl',
      container: 'h-full',
      item: 'h-full',
      dot: 'h-3 w-3 rounded-full data-[state=active]:bg-primary data-[state=active]:scale-125'
    }"
  >
    <div class="relative w-full h-full">
      <NuxtImg
        v-if="item?.background_image"
        :src="item.background_image"
        :alt="item?.name ?? 'Imagem do jogo'"
        format="webp"
        class="w-full h-full object-cover aspect-video object-top"
      />

      <div class="flex items-end pointer-events-none absolute inset-0 bg-linear-to-t from-black/85 via-black/50 to-transparent">
        <LazyVisibleHomeCarouselGameCard
          hydrate-on-visible
          :item="item"
          variant="ghost"
        />
      </div>
    </div>
  </UCarousel>
</template>
